import React from 'react'

import { GrInstagram,
        GrGithub,
        GrLinkedinOption} from 'react-icons/gr';

const Social = () => {
  return (
   <div className="home__social">
   <a href="https://www.linkedin.com/in/ewerton-lopes-pereira/" className="home__social-icon" target="_blank" rel="noreferrer">
   <GrLinkedinOption />
   </a>
   <a href="https://www.instagram.com/ewerton_lp" className="home__social-icon" target="_blank" rel="noreferrer">
   <GrInstagram />
   </a>
   <a href="https://www.github.com/ewertonlp" className="home__social-icon" target="_blank" rel="noreferrer">
    <GrGithub />
   </a>
   </div>
  )
}

export default  Social;